"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindDisney = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bindClient_1 = require("../../model/bindClient");
var service_1 = require("../../../library/base/service");
var BindDisney = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BindDisney, _super);
    function BindDisney() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '迪士尼活动绑定';
        _this.code = '300425';
        _this.desc = '迪士尼活动绑定';
        _this.requestParams = new bindClient_1.BindRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return BindDisney;
}(service_1.BaseService));
exports.BindDisney = BindDisney;
//# sourceMappingURL=bindDisney.js.map